import { useEffect } from 'react';

export const BlankPageStub = () => {
  // TODO: Принудительная перезагрузка, если попали на страницу-заглушку
  useEffect(() => {
    location.reload();
  }, []);

  return <div />;
};
